import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router/composables'
export const useVoucherList = () => {
  const router = useRouter()
  const route = useRoute()
  const showAllVoucherState = ref(false)
  const PRODUCT_EXTRACTORS = {
    'main-voucher': (voucher) => voucher?.concurrency?.[0]?.is_exclude ?? false,
    'popup-voucher': (voucher) => voucher?.is_exclude ?? false,
  }

  const showAllVoucherButton = (voucherList = [], type) => {
    const { query } = route
    if (query?.['all-voucher'] === 'y') {
      showAllVoucherState.value = false
      return
    }
    const extractor = PRODUCT_EXTRACTORS[type]

    showAllVoucherState.value = voucherList.some((voucher) =>
      extractor(voucher),
    )
    return showAllVoucherState.value
  }

  const getFilteredVoucherList = (voucherList, type) => {
    const { query } = route
    if (!showAllVoucherState.value && query?.['all-voucher'] === 'y') {
      return voucherList
    }

    const extractor = PRODUCT_EXTRACTORS[type]
    return voucherList.filter((voucher) => !extractor(voucher))
  }

  const hideAllVoucherButton = () => {
    const { name, query } = route
    showAllVoucherState.value = false
    window.scrollTo({ top: 0, behavior: 'smooth' })

    router.replace({
      name,
      query: { ...query, 'all-voucher': 'y' },
    })
  }

  return {
    showAllVoucherButton,
    getFilteredVoucherList,
    hideAllVoucherButton,
    showAllVoucherState,
  }
}
